import AppView from '@/Framework/app/components/ApplicationView/AppView.vue';

//to be implemented further
const to = 'to';
const from = 'from';

export default class View {
	public id: string;
	private busy = false;
	private component = new AppView();

	constructor(id: string) {
		this.id = id;
	}

	public setComponent(component: AppView): void {
		this.component = component;

		this.component.$nextTick(() => {
			this.onActivate(to, from, window.aps.context);
		});
	}

	protected onActivate(to: string, from: string, data: APS.ICustomData): void {
		const payload = {
			to,
			from,
			data,
			next: null,
			listener: 'onActivate'
		};

		this.component.apply(payload);
	}

	public apply(functionName: string, data: APS.ICustomData): void {
		if (functionName === '_onContext') {
			//@ts-ignore -- check private vue properties
			if (!this.component._isDestroyed && this.component._vnode) {
				this.onActivate(to, from, window.aps.context);
			}
		}

		const events = ['onNext', 'onPrev', 'onCancel', 'onSubmit'];

		if (window.aps.wizard.active && events.includes(functionName) && !this.busy) {
			const next = this.createNextFunction(functionName);

			const payload: APS.ILifecyclePayload = {
				to,
				from,
				next,
				data,
				listener: `onBefore${functionName.substr(2)}`
			};
			this.busy = true;
			this.component.apply(payload);
		}
	}

	private performTransition(functionName: string, returnValue: APS.IReturnValue): void {
		if (functionName === 'onNext') {
			window.aps.apsc.next(returnValue);
		}
		if (functionName === 'onPrev') {
			window.aps.apsc.prev(returnValue);
		}
		if (functionName === 'onCancel') {
			window.aps.apsc._goBack();
		}
		if (functionName === 'onSubmit') {
			window.aps.apsc._goBack();
		}
	}

	private createNextFunction(functionName: string): APS.ILifecycleNextFunction {
		let next!: (returnValue: APS.IReturnValue) => void;

		new Promise((resolve) => {
			next = resolve;
		})
			.then((returnValue: APS.IReturnValue) => {
				if (returnValue !== false) {
					this.performTransition(functionName, returnValue);
				}
			})
			.finally(() => {
				this.busy = false;
			});

		return next;
	}
}
